<template>
  <div class="privacy-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.privacyTitle') }}</h1>
      <p>{{ $t('common.privacy00') }}</p>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.privacy01', { company: companyName }) }}</p>
      <ul>
        <li>{{ $t('common.privacy02') }}<a href="./privacy-summary.html" target="_blank">{{ $t('common.privacy03') }}</a>{{ $t('common.privacy04') }}</li>
        <li>{{ $t('common.privacy05') }}<a href="./personal-information.html" target="_blank">{{ $t('common.privacy06') }}</a>{{ $t('common.privacy07') }}</li>
        <li>{{ $t('common.privacy08') }}<a href="./authorization.html" target="_blank">{{ $t('common.privacy09') }}</a>{{ $t('common.privacy10') }}</li>
        <li>{{ $t('common.privacy11') }}</li>
        <li>{{ $t('common.privacy12') }}</li>
      </ul>
      <p>{{ $t('common.privacy13') }}</p>
      <h2>{{ $t('common.privacyTitle01') }}</h2>
      <p>{{ $t('common.privacy14') }}</p>
      <h3>{{ $t('common.privacyTitle0101') }}</h3>
      <p>{{ $t('common.privacy16') }}</p>
      <h3>{{ $t('common.privacyTitle0102') }}</h3>
      <p>{{ $t('common.privacy17') }}</p>
      <h3>{{ $t('common.privacyTitle0103') }}</h3>
      <p>{{ $t('common.privacy18') }}</p>
      <ul>
        <li>{{ $t('common.privacy19') }}</li>
        <li>{{ $t('common.privacy20') }}</li>
        <li>{{ $t('common.privacy21') }}</li>
      </ul>
      <h3>{{ $t('common.privacyTitle0104') }}</h3>
      <p>{{ $t('common.privacy22') }}</p>
      <h3>{{ $t('common.privacyTitle0105') }}</h3>
      <p>{{ $t('common.privacy23') }}</p>
      <h3>{{ $t('common.privacyTitle0106') }}</h3>
      <p>{{ $t('common.privacy24') }}</p>
      <h3>{{ $t('common.privacyTitle0107') }}</h3>
      <p>{{ $t('common.privacy25') }}</p>
      <ul>
        <li>{{ $t('common.privacy26') }}</li>
        <li>{{ $t('common.privacy27') }}</li>
        <li>{{ $t('common.privacy28') }}</li>
        <li>{{ $t('common.privacy29') }}</li>
        <li>{{ $t('common.privacy30') }}</li>
        <li>{{ $t('common.privacy31') }}</li>
        <li>{{ $t('common.privacy32') }}</li>
        <li>{{ $t('common.privacy33') }}</li>
        <li>{{ $t('common.privacy34') }}</li>
        <li>{{ $t('common.privacy35') }}</li>
        <li>{{ $t('common.privacy36') }}</li>
        <li>{{ $t('common.privacy37') }}</li>
      </ul>
      <h2>{{ $t('common.privacyTitle02') }}</h2>
      <p>{{ $t('common.privacy38') }}</p>
      <ul>
        <li>{{ $t('common.privacy39') }}</li>
        <li>{{ $t('common.privacy40') }}</li>
      </ul>
      <p>{{ $t('common.privacy41') }}</p>
      <h2>{{ $t('common.privacyTitle03') }}</h2>
      <h3>{{ $t('common.privacyTitle0301') }}</h3>
      <p>{{ $t('common.privacy42') }}</p>
      <p>{{ $t('common.privacy43') }}<a href="./third-party.html" target="_blank">{{ $t('common.privacy44') }}</a>{{ $t('common.privacy45') }}</p>
      <h3>{{ $t('common.privacyTitle0302') }}</h3>
      <p>{{ $t('common.privacy46') }}</p>
      <h3>{{ $t('common.privacyTitle0303') }}</h3>
      <p>{{ $t('common.privacy47') }}</p>
      <h3>{{ $t('common.privacyTitle0304') }}</h3>
      <p>{{ $t('common.privacy48') }}</p>
      <ul>
        <li>{{ $t('common.privacy49') }}</li>
        <li>{{ $t('common.privacy50') }}</li>
        <li>{{ $t('common.privacy51') }}</li>
        <li>{{ $t('common.privacy52') }}</li>
        <li>{{ $t('common.privacy53') }}</li>
        <li>{{ $t('common.privacy54') }}</li>
        <li>{{ $t('common.privacy55') }}</li>
        <li>{{ $t('common.privacy56') }}</li>
        <li>{{ $t('common.privacy57') }}</li>
        <li>{{ $t('common.privacy58') }}</li>
        <li>{{ $t('common.privacy59') }}</li>
        <li>{{ $t('common.privacy60') }}</li>
      </ul>
      <h2>{{ $t('common.privacyTitle04') }}</h2>
      <h3>{{ $t('common.privacyTitle0401') }}</h3>
      <p>{{ $t('common.privacy61') }}</p>
      <h3>{{ $t('common.privacyTitle0402') }}</h3>
      <p>{{ $t('common.privacy62') }}</p>
      <ul>
        <li>{{ $t('common.privacy63') }}</li>
        <li>{{ $t('common.privacy64') }}</li>
      </ul>
      <h2>{{ $t('common.privacyTitle05') }}</h2>
      <p>{{ $t('common.privacy65') }}</p>
      <p>{{ $t('common.privacy66') }}</p>
      <p>{{ $t('common.privacy67') }}</p>
      <p>{{ $t('common.privacy68') }}</p>
      <p>{{ $t('common.privacy69') }}</p>
      <h2>{{ $t('common.privacyTitle06') }}</h2>
      <p>{{ $t('common.privacy70') }}</p>
      <p>{{ $t('common.privacy71') }}</p>
      <p>{{ $t('common.privacy72') }}</p>
      <h3>{{ $t('common.privacyTitle0601') }}</h3>
      <p>{{ $t('common.privacy73') }}</p>
      <h3>{{ $t('common.privacyTitle0602') }}</h3>
      <p>{{ $t('common.privacy75') }}</p>
      <h3>{{ $t('common.privacyTitle0603') }}</h3>
      <p>{{ $t('common.privacy76') }}</p>
      <p>{{ $t('common.privacy77') }}</p>
      <h3>{{ $t('common.privacyTitle0604') }}</h3>
      <p>{{ $t('common.privacy78') }}</p>
      <h2>{{ $t('common.privacyTitle07') }}</h2>
      <p>{{ $t('common.privacy79') }}</p>
      <p>{{ $t('common.privacy80') }}</p>
      <h2>{{ $t('common.privacyTitle08') }}</h2>
      <p>{{ $t('common.privacy81') }}</p>
      <p>{{ $t('common.privacy82') }}</p>
      <h2>{{ $t('common.privacyTitle09') }}</h2>
      <p>{{ $t('common.privacy83') }} <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>{{ $t('common.privacy84') }}</p>
      <p>{{ $t('common.privacy85') }}</p>
      <h2>{{ $t('common.privacyTitle10') }}</h2>
      <p>{{ $t('common.privacy86') }}</p>
      <p>{{ $t('common.privacy87') }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
  companyName: {
    type: String,
    required: true,
  },
  contactEmail: {
    type: String,
    required: true,
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.privacyTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
